<template>
	<v-container fluid class="signup" no-gutter>
		<v-layout row>
			<v-flex xs12 sm8 >
				<v-flex xs12 v-if="isMobile">
					<div
						class="mobile-banner"
						:style="{ background: 'url(' + getBanner('mobile') + ')' }"
					></div>
				</v-flex>
				<div class="logo-container">
					<img :src="appLogo" class="logo-img" />
				</div>
				<v-container align-center>
					<v-layout row align-center>
						<v-spacer />
						<v-flex xs12 sm7>
							<v-spacer />
							<v-form autocomplete="nope">
								<h2 class="mb-3">{{ $t("message.loginToStore") }}</h2>
								<v-text-field
									:error-messages="errors.collect('email')"
									data-vv-name="email"
									:label="$t('message.email')"
									required
									v-model="email"
									v-validate="'required|email'"
									solo
									flat
									background-color="#e6e6e6"
									class="roundInput"
								></v-text-field>

								<v-text-field
									:error-messages="errors.collect('password')"
									data-vv-name="password"
									:label="$t('message.password')"
									required
									type="password"
									v-model="password"
									v-validate="'required|min:6'"
									solo
									flat
									background-color="#e6e6e6"
									class="roundInput"
								></v-text-field>
								<div class="login-buttons">
									<v-btn
										color="#e6e6e6"
										@click="submit"
										block
										large
										depressed
										round
										>{{ $t("message.loginNow") }}</v-btn
									>
									<v-btn
										@click="onCreateAccount"
										color="#262261"
										class="white--text"
										block
										large
										depressed
										round
										>{{ $t("message.createAccount") }}</v-btn
									>
								</div>
								<div class="center-text">
									<router-link to="/session/forgot-password"
										>{{ $t("message.forgotPassword") }}?</router-link
									>
								</div>
								<div class="center-text">
									<a href="https://t.me/tubotones">{{
										$t("message.joinCommunity")
									}}</a>
								</div>
							</v-form>
							<v-spacer />
						</v-flex>
						<v-spacer />
					</v-layout>
				</v-container>
			</v-flex>
			<v-flex xs0 sm4>
				<div
					class="banner"
					:style="{ background: 'url(' + getBanner('web') + ')' }"
				></div>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
// import firebase from 'firebase/app'
import { mapGetters } from "vuex";
import SessionSliderWidget from "Components/Widgets/SessionSlider";
import AppConfig from "Constants/AppConfig";

import AuthService from "../../auth/AuthService";
import { API_LOGIN } from "../../store/modules/auth/actions.types";

const auth = new AuthService();
const { login, logout, authenticated, authNotifier } = auth;

export default {
	components: {
		SessionSliderWidget,
	},
	data() {
		return {
			checkbox: false,
			valid: false,
			email: "",
			password: "",
			appLogo: AppConfig.appLogo,
			brand: AppConfig.brand,
		};
	},
	computed: {
		isMobile() {
			return this.$vuetify.breakpoint.name == "xs";
		},
	},
	methods: {
		getBanner(media) {
			const urlFor = {
				mobile: "/static/img/banner/mobile_red.jpg",
				web: "/static/img/banner/web_red.jpg",
			};
			return urlFor[media];
		},
		async submit() {
			try {
				const valid = await this.$validator.validateAll();
				const user = {
					email: this.email,
					password: this.password,
				};

				if (valid) {
					this.$store.dispatch(API_LOGIN, user);
				}
			} catch (err) {
				console.error(err);
			}
		},
		onCreateAccount() {
			this.$router.push("/session/sign-up");
		},
		signinWithAuth0() {
			login();
		},
	},
};
</script>
<style lang="scss">
.logo-container {
	max-height: 56px !important;
	padding: 12px;
}
.logo-img {
	width: 150px;
	max-width: 32%;
}

.roundInput.v-input .v-input__slot {
	border-radius: 10px !important;
}
.signup .v-btn--round {
	border-radius: 10px !important;
}
.banner-placeholder {
	background-color: blue;
}
.signup {
	display: flex;
	align-content: stretch;
}
.signup form p,
.signup form a {
	color: #262261;
}
.center-text {
	text-align: center;
}
.login-buttons > * {
	margin-bottom: 16px;
}
.banner {
	background-repeat: no-repeat !important;
	background-size: cover !important;
}
.mobile-banner {
	background-repeat: no-repeat !important;
	background-size: cover !important;
	width: 100%;
	height: 100%;
	min-height: 10vh;
}
</style>
